import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import '../../fonts/fonts.css'
import SideBar from '../SideBar'
import { connect, useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import injectSaga from '../../utils/injectSaga'
import { simuPlayerTrainingsData, deleteSimuPlayerSaga } from './saga'
import { simuPlayerTrainings, deleteSimuPlayer, hideModal } from '../App/actions'
import MainTitle from '../../components/MainTitle'
import pen from '../../images/pen.svg'
import ModalConfirm from '../../components/ModalConfirm'
import { 
  DashboardContainer, ButtonContainer, Success, ImgSuccess, TextSuccess,
  Bg, MainLayout, MainContainer, FormContainer, BoxContainer, Name,
  SelectorLicenceContainer, LicenceSelector,
  TrainingChoices, TrainingInput, TrainingLabel, 
  DeleteButton, Button, ErrorContainer, FeedBack } from './styledComponents'
import Dashboard from '../../components/Dashboard'
import InfoContainer from '../../components/SimuPlayer_InfoContainer'

import CheckboxOff from '../../images/checkboxOff.svg'
import CheckboxOn from '../../images/checkboxOn.svg'

import "./styles.css"

const SimuPlayerTrainings = (props) => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const players = useSelector((state) => state.toJS().global.simuPlayers)
  const error = useSelector((state) => state.toJS().global.error)
  const loading = useSelector((state) => state.toJS().global.loading)
  const token = useSelector((state) => state.toJS().global.agencytoken)
  const successStore = useSelector((state) => state.toJS().global.success)
  const trainings =  useSelector((state) => state.toJS().global.trainings)
  const agencyTrainings = useSelector((state) => state.toJS().global.agencyTrainings)

  const id = location.query ? location.query.id : location.pathname.split('/')[3]
  const player = players ? players.find(player => player.id === id || player._id === id) : ''

  const [success, setSuccess] = useState()
  const [playerId, setPlayerId] = useState(id)
  const [playerAgency, setPlayerAgency] = useState(player.agencyId)
  const [playerTrainings, setPlayerTrainings] = useState([...(player.availableTrainings || [])])
  console.log('playerTrainings',playerTrainings)
  console.log('player.availableTrainings', player.availableTrainings)
  console.log('player', player)
  const [modalName, setModalName] = useState()
  const [modalText, setModalText] = useState()
  const [warn, setWarn] = useState({ lastname: false, firstname: false, mail: false, psw: false, repPsw: false, error: false })
  const [showModal, setShowModal] = useState(false)
  const [errorCode, setErrorCode] = useState(0)
  const [playerLicence, setPlayerLicence] = useState(player.trainingType || '')
  const [availableTrainings, setAvailableTrainings] = useState([]);
  useEffect(() => {
    displayModal(successStore)
    errorCheck(error)
    if (agencyTrainings) {
      const filteredTrainings = agencyTrainings
      .map(training => training.title)
      setAvailableTrainings(filteredTrainings)
    }
    // eslint-disable-next-line
  }, [player._id, loading, successStore, error])

  const errorCheck = (err) => {
    if (err) {
      switch (error) {
        case "Failed to fetch":
          setSuccess(false); setWarn({ error: true }); setModalText('Impossible d\'accéder au serveur'); setErrorCode(error)
          break
        default:
          setSuccess(false); setWarn({ error: true }); setModalText('Erreur'); setErrorCode(error)
      }
    }
  }

  const displayModal = (show) => {
    if(show){
      setSuccess(true)
      setTimeout(() => {
        dispatch(hideModal())
        setSuccess(false)
      }, 2000);
    }
  }


  const handleClick = () => {
    dispatch(simuPlayerTrainings({ id, token: token, trainingType: playerLicence, trainings: playerTrainings,availableTrainings: playerTrainings }))
  }

  function handleChangeLicence (e) {
    setPlayerLicence(e.value)
  }

  const licences = [
    {value: 'B', label: 'B'},
    {value: 'BEA', label: 'BEA'},
    {value: 'AAC', label: 'AAC'},
    {value: 'BEA AAC', label: 'BEA AAC'}
  ]

  const DisplayLicenceSelector = () => {
    let currentLicenceIndex = licences.indexOf(licences.find((li) => li.value === player.trainingType))

      return (
        <LicenceSelector
          classNamePrefix='react-select'
          multiple={false}
          isSearchable={false}
          defaultValue={licences[currentLicenceIndex]}
          onChange={(e) => {handleChangeLicence(e)}}
          options={licences}>
        </LicenceSelector>
      )
  }


  const Checkbox = ({ name, boxChecked, onChange }) => {
    return (
      <TrainingLabel className='trainingChoice'>
          <TrainingInput type="checkbox" id={name} value={name} checked={boxChecked} onChange={onChange} />
          <img className="checkbox-img-checked" alt="check" src={CheckboxOn} width="16px" height="14px"></img>
          <img className="checkbox-img-unchecked" alt="uncheck" src={CheckboxOff} width="16px" height="14px"></img>
          <TrainingLabel htmlFor={name}>{name}</TrainingLabel>
      </TrainingLabel>
    );
  };

  const workshopTitles = ['EVAL', 'REMC']

  const getTrainingTitles = (isWorkshop) => {
    if (!agencyTrainings) return []
    if (typeof agencyTrainings[0] === 'string') {
      return agencyTrainings.filter(t => isWorkshop ? workshopTitles.includes(t) : !workshopTitles.includes(t))
    }
    return agencyTrainings.filter(t => isWorkshop ? t.isWorkshop : !t.isWorkshop).flatMap(t => t.title)
  }

  const displayTrainingsChoices = () => {
    if (agencyTrainings) {
      return (
        <TrainingChoices>
          {getTrainingTitles(true).map((title, index) => {
              return (
                <Checkbox
                  key={index}
                  name={title}
                  boxChecked={playerTrainings.includes(title)}
                  onChange={() => handleTrainingClick(title)}
                />
              )
            })}
        </TrainingChoices>
      );
    } else {
      return <TrainingChoices></TrainingChoices>
    }
  }

  const displayTrainingsChoices2 = () => {
    if (agencyTrainings) {
      return (
        <TrainingChoices>
          {getTrainingTitles(false).map((title, index) => {
              return (
                <Checkbox
                  key={index}
                  name={title}
                  boxChecked={playerTrainings.includes(title)}
                  onChange={() => handleTrainingClick(title)}
                />
              )
            })}
        </TrainingChoices>
      );
    } else {
      return <TrainingChoices></TrainingChoices>
    }
  }

  const handleTrainingClick = (trainingTitle) => {
    setPlayerTrainings(prevTrainings => {
      if (prevTrainings.includes(trainingTitle)) {
        return prevTrainings.filter(t => t !== trainingTitle);
      } else {
        return [...prevTrainings, trainingTitle];
      }
    });
  };

  function renderSuccess () {
    return (
      <Success>
        <ImgSuccess />
        <TextSuccess>L'élève à bien été modifié !</TextSuccess>
      </Success>
    )
  }

  function confirmDelete (id, action, firstname) {
    setShowModal(true)
    setPlayerId(id)
    setModalText(`${action}`)
    setModalName(`${firstname}`)
  }

  const deletePlayer = (id) => { // FIXME: set timeout ???
    dispatch(deleteSimuPlayer(token, id, playerAgency))
    setTimeout(() => {
      history.push('/simuplayers')
    }, 100)
  }


  if (!player.firstname) {
    return <div>LOADING</div>
  }

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        {success
          ? renderSuccess()
          : <div />}
        <MainTitle text='Choix de formations' icon={pen} />
        <MainContainer>
        <ModalConfirm 
          show={showModal}
          confirmText='Supprimer'
          text={modalText} 
          name={modalName} 
          confirm={() => deletePlayer(playerId)}
          cancel={() => setShowModal(false)}
        />

        <DashboardContainer>
          <Dashboard height={'48px'} type='edit' data={{firstName: player.firstname, lastName: player.lastname}}/>
        </DashboardContainer>
        <InfoContainer path={location.pathname} playerId={playerId} />
        <FormContainer>
          <div />
          <BoxContainer>
              <Name>Permis</Name>
              <SelectorLicenceContainer>
                {DisplayLicenceSelector()}
              </SelectorLicenceContainer>
          </BoxContainer>
          {/*<BoxContainer>
            <Name>Formations général</Name>
            {displayTrainingsChoices()}
          </BoxContainer>
          <BoxContainer style={{marginTop:'1rem'}}>
            <Name>Formations personnalisées</Name>
            {displayTrainingsChoices2()}
          </BoxContainer>
          */}
          <ButtonContainer>
            <DeleteButton onClick={() => confirmDelete(id, 'Attention, vous allez supprimer définitivement le compte de ', (player.firstname + ' ' + player.lastname))}>Supprimer</DeleteButton>
            <Button data-type='premium' style={{ backgroundColor: '#00C4F3', color:'black', cursor: 'pointer' }} onClick={() => handleClick()}>
              Enregistrer les modifications
            </Button>
          </ButtonContainer>
        </FormContainer>
        <ErrorContainer>
          <FeedBack style={{ opacity: warn.error ? '1' : '0' }}>{modalText}</FeedBack>
        </ErrorContainer>
        </MainContainer>
      </MainLayout>
    </Bg>
  )
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'simuPlayerTrainings', saga: simuPlayerTrainingsData })
const withDeleteSaga = injectSaga({ key: 'deleteSimuPlayer', saga: deleteSimuPlayerSaga })

const arg = compose(withSaga, withDeleteSaga, withConnect)(SimuPlayerTrainings)

export default arg
